import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AgentLeads() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/agent/leads").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  return (
    <div data-testid="agent-leads-page">
      <div className="eyebrow mb-2">Pipeline</div>
      <h1 className="aperture-h1 text-4xl mb-10">Leads.</h1>

      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Lead ID","Name","Property Address","Created"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {rows === null && <tr><td colSpan="4" className="px-4 py-10 text-center text-navy/50">Loading…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan="4" className="px-4 py-10 text-center text-navy/50">No leads yet.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.lead_id} className="border-t" data-testid={`lead-row-${r.lead_id}`} style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3 font-mono text-xs">{r.lead_id}</td>
                <td className="px-4 py-3">{r.name || "—"}</td>
                <td className="px-4 py-3 text-navy/70">{r.property_address || "—"}</td>
                <td className="px-4 py-3 text-navy/60 text-xs">{r.created_at ? new Date(r.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
